export const enforceHttpsUrlString = (url: string) => {
	if (url === '') return url;

	url = url.replace(/^http:\/\//, 'https://');
	if (!url.match(/^https:\/\//)) url = `https://${url}`;
	return url;
};

export default enforceHttpsUrlString;
